import Paper from "@material-ui/core/Paper";
import React from "react";

export const REMOVE_DROP_SHADOW = {
    Container: props => <Paper {...props} elevation={0}/>,
};